var map = {
	"./age_rating_0.svg": 835,
	"./age_rating_12.svg": 836,
	"./age_rating_16.svg": 837,
	"./age_rating_18.svg": 838,
	"./age_rating_7.svg": 839,
	"./app_store.svg": 840,
	"./app_store_full.svg": 841,
	"./appstore.svg": 842,
	"./blik.svg": 843,
	"./calendar.svg": 844,
	"./cards.svg": 845,
	"./checkIcon.svg": 304,
	"./close.svg": 846,
	"./close_thin.svg": 847,
	"./device_pc.svg": 848,
	"./device_phone.svg": 849,
	"./device_tablet.svg": 850,
	"./device_tv.svg": 851,
	"./exit_fullscreen.svg": 852,
	"./facebook.svg": 853,
	"./fullscreen-vod.svg": 854,
	"./fullscreen.svg": 855,
	"./google_play_full.svg": 856,
	"./googleplay.svg": 857,
	"./gpay.svg": 858,
	"./ic_adult.svg": 859,
	"./ic_arrow_down.svg": 860,
	"./ic_arrow_l.svg": 861,
	"./ic_arrow_r.svg": 862,
	"./ic_auth_apple.svg": 863,
	"./ic_auth_facebook.svg": 864,
	"./ic_auth_google.svg": 865,
	"./ic_basket.svg": 866,
	"./ic_bell.svg": 867,
	"./ic_blik.svg": 868,
	"./ic_bluemedia.svg": 869,
	"./ic_clock.svg": 870,
	"./ic_close.svg": 871,
	"./ic_close_thin.svg": 872,
	"./ic_favorite.svg": 873,
	"./ic_favorite_border.svg": 874,
	"./ic_favorite_full.svg": 875,
	"./ic_favourite.svg": 876,
	"./ic_gears.svg": 877,
	"./ic_grid.svg": 878,
	"./ic_list.svg": 879,
	"./ic_live.svg": 880,
	"./ic_lock.svg": 881,
	"./ic_lock_second.svg": 882,
	"./ic_mastercard.svg": 883,
	"./ic_more_info.svg": 884,
	"./ic_phone.svg": 885,
	"./ic_play.svg": 886,
	"./ic_profile.svg": 887,
	"./ic_rec.svg": 888,
	"./ic_reminder.svg": 889,
	"./ic_search.svg": 890,
	"./ic_share.svg": 891,
	"./ic_tick.svg": 892,
	"./ic_trash.svg": 893,
	"./ic_tv.svg": 894,
	"./ic_visa.svg": 895,
	"./laptop.svg": 896,
	"./logo_maxelectro.svg": 897,
	"./logo_vectra.svg": 898,
	"./mastercard.svg": 899,
	"./minimalize.svg": 900,
	"./mobile.svg": 901,
	"./new_ic_bell.svg": 902,
	"./nexgentv.svg": 903,
	"./nexgentv_go.svg": 183,
	"./next.svg": 904,
	"./pause.svg": 905,
	"./phone.svg": 906,
	"./placeholder.svg": 907,
	"./play.svg": 908,
	"./previous.svg": 909,
	"./promotion.svg": 524,
	"./seek_15_next.svg": 910,
	"./seek_15_prev.svg": 911,
	"./settings.svg": 912,
	"./star_empty.svg": 913,
	"./star_full.svg": 914,
	"./test/search_icon.svg": 915,
	"./test/share_icon.svg": 916,
	"./tick.svg": 917,
	"./triangle-border.svg": 918,
	"./triangle.svg": 919,
	"./tv.svg": 920,
	"./underline.svg": 921,
	"./vectra_logo.svg": 922,
	"./vectra_new_logo.svg": 923,
	"./visa.svg": 924,
	"./vod_heart.svg": 925,
	"./vod_heart_full.svg": 926,
	"./vod_play.svg": 927,
	"./volume.svg": 928,
	"./volume_off.svg": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 834;